<div #contentContainer [innerHTML]="renderedContent"></div>

